export default __webpack_public_path__ + "static/bc-logo-svg-c9304932e64e92d7d767234c43d663e3.svg";